import { Navigate, createFileRoute } from "@tanstack/react-router";
import { SeatOrgKind } from "@sx/protocol/fleet/supervision";

import { TeleoperatorsPeoplePage } from "../../../workspaces/fleet/pages/TeleoperatorsPeoplePage";
import { useSeat } from "../../../workspaces/fleet/seat";

/** Who holds a seat, who is on a robot now and what each one drove. A teleop vendor reads
 * no fleet's seats; its home is the help queue. */
export const Route = createFileRoute("/_console/teleoperators/people")({
  component: People,
});

function People() {
  const seat = useSeat();
  if (seat.orgKind === SeatOrgKind.TELEOP_VENDOR) return <Navigate to="/teleoperators" replace />;
  return <TeleoperatorsPeoplePage />;
}
